import { Popover, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import { ArrowDown } from "../assets/icons/arrowDownIcon";
import { Link } from "gatsby";
import {
  DataCuration,
  DataLabeling,
  Agents,
  ModelLabeling,
  LabelingServicesIcon,
} from "../assets/icons/NavbarIcons/Icons";

import { headerTheme } from "./Header";
import { ForwardArrow } from "../assets/icons";
import CustomButton from "../components/CustomButton";
import productDemoImage from "../assets/images/product-demo-4x.png";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const platForm = [
  {
    heading: "Data management & curation",
    icon: <DataCuration />,
    hoveredIcon: <DataCuration fill={"#5E44FF"} />,
    link: "/encord-index/",
  },
  {
    heading: "Data annotation",
    icon: <DataLabeling />,
    hoveredIcon: <DataLabeling fill={"#5E44FF"} />,
    link: "/annotate/",
  },
  {
    heading: "Model evaluation",
    icon: <ModelLabeling />,
    hoveredIcon: <ModelLabeling fill={"#5E44FF"} />,
    link: "/active/",
  },
  {
    heading: "Data agents",
    icon: <Agents />,
    hoveredIcon: <Agents fill={"#5E44FF"} fill2={"#5E44FF"} />,
    link: "/data-agents/",
  },
  {
    heading: "Labeling services",
    icon: <LabelingServicesIcon />,
    hoveredIcon: <LabelingServicesIcon fill={"#5E44FF"} fill2={"#5E44FF"} />,
    link: "/accelerate/",
  },
];

const solutionForm = [
  {
    heading: "Physical AI",
    link: "/physical-ai/",
  },
];

const modalities = [
  {
    heading: "Multimodal",
    link: "/multimodal/",
  },
  {
    heading: "Image",
    link: "/image/",
  },
  {
    heading: "Video",
    link: "/video/",
  },
  {
    heading: "Document & text",
    link: "/document/",
  },
  {
    heading: "Audio",
    link: "/audio/",
  },
  {
    heading: "DICOM & NIfTI",
    link: "/dicom/",
  },
  {
    heading: "LiDAR",
    link: "/lidar/",
  },
];

const ProductHeaderButton = React.forwardRef(
  ({ theme, handleEnter, handleLeave, isHover, textColor, iconColor }, ref) => {
    const [hoveredIndex, setHoveredIndex] = useState(0);
    useEffect(() => {
      setHoveredIndex(0);
    }, [isHover]);
    const [platformActive, isPlatformActive] = useState(false);

    return (
      <Popover
        className="relative"
        onMouseEnter={handleEnter}
        onMouseLeave={handleLeave}
        ref={ref}
      >
        {({ open }) => (
          <>
            <div>
              <Popover.Button
                className={classNames(
                  isHover
                    ? headerTheme[theme].hoverTextColor
                    : textColor || headerTheme[theme].textColor,
                  "group rounded-md inline-flex gap-2 items-center text-sm lgxl_mid:text-base font-medium focus:outline-none ",
                )}
              >
                <span>Platform</span>

                <ArrowDown
                  fill={
                    isHover
                      ? headerTheme[theme].hoverIcon
                      : iconColor || headerTheme[theme].icon
                  }
                  className={`transition-transform duration-500 ${
                    isHover ? "rotate-180" : "rotate-0"
                  }`}
                />
              </Popover.Button>

              <Transition
                show={isHover}
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 -translate-y-1"
                enterTo="opacity-100 translate-y-0"
                null
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel className="fixed z-10 inset-x-0 mt-[22px] hidden lg:block">
                  <div className="w-screen bg-white border-none shadow-neutral-500/10 shadow-md">
                    <div>
                      <nav
                        className="flex bg-white rounded-lg"
                        aria-labelledby="solutions-heading"
                      >
                        <section className="flex-auto bg-white navbar-bg h-auto">
                          <section className="flex gap-1 flex-row max-w-7xl mx-auto px-6 xl:px-16">
                            <section className="flex-1 min-w-[285px] px-6 md:pr-6 md:pl-0">
                              <p className="px-2 pb-2 pt-[14px] font-medium text-[#AAAAAA]">
                                Product
                              </p>
                              {platForm?.map((value, index) => {
                                return (
                                  <Link
                                    key={index}
                                    to={value?.link}
                                    className="p-2 navbar-hover-bg flex items-center gap-2 justify-between group"
                                  >
                                    <div className="flex gap-1.5 items-center">
                                      <p className="text-xl text-gray-2500 group-hover:text-gray-2700 font-medium tracking-tighter_3">
                                        {value?.heading}
                                      </p>
                                    </div>
                                    <ForwardArrow
                                      fill={"#5E44FF"}
                                      className="opacity-0 group-hover:opacity-100"
                                    />
                                  </Link>
                                );
                              })}

                              <p className="px-2 pb-2 pt-[14px] font-medium text-[#AAAAAA]">
                                Solution
                              </p>
                              {solutionForm?.map((value, index) => {
                                return (
                                  <Link
                                    key={index}
                                    to={value?.link}
                                    className="p-2 navbar-hover-bg flex items-center gap-2 justify-between group"
                                  >
                                    <div className="flex gap-1.5 items-center">
                                      <p className="text-xl text-gray-2500 group-hover:text-gray-2700 font-medium tracking-tighter_3">
                                        {value?.heading}
                                      </p>
                                    </div>
                                    <ForwardArrow
                                      fill={"#5E44FF"}
                                      className="opacity-0 group-hover:opacity-100"
                                    />
                                  </Link>
                                );
                              })}

                              <p className="px-2 pb-2 pt-[14px] font-medium text-[#AAAAAA]">
                                Security and governance
                              </p>
                              <Link
                                to="/security/"
                                className="p-2 navbar-hover-bg flex items-center gap-2 justify-between group"
                              >
                                <div className="flex gap-1.5 items-center">
                                  <p className="text-xl text-gray-2500 group-hover:text-gray-2700 font-medium tracking-tighter_3">
                                    Security
                                  </p>
                                </div>
                                <ForwardArrow
                                  fill={"#5E44FF"}
                                  className="opacity-0 group-hover:opacity-100"
                                />
                              </Link>
                            </section>

                            <section className="flex-1 pb-2 min-w-[285px] px-6">
                              <p className="px-2 pb-2 pt-[14px] font-medium text-[#AAAAAA]">
                                Modalities
                              </p>
                              {modalities?.map((value, index) => {
                                return (
                                  <Link
                                    key={index}
                                    to={value?.link}
                                    className="p-2 navbar-hover-bg flex items-center group justify-between"
                                  >
                                    <div className="flex gap-1.5 items-center">
                                      <p className="text-xl text-gray-2500 group-hover:text-gray-2700 font-medium tracking-tighter_3">
                                        {value?.heading}
                                      </p>
                                    </div>
                                    <ForwardArrow
                                      fill={"#5E44FF"}
                                      className="hidden group-hover:inline-block"
                                    />
                                  </Link>
                                );
                              })}
                            </section>

                            <div className="w-96 rounded-tr-[4px] justify-center flex rounded-br-[4px]">
                              <Link
                                to="/explore-product/?utm_source=navbar&utm_medium=banner&utm_campaign=product_demo&utm_content=platform_dropdown"
                                className="group overflow-hidden cursor-pointer rounded-[2px] flex flex-col
                 bg-cover bg-center justify-end bg-gradient-to-b from-[#E1DEF5]/40 to-[#FAFAFA]"
                              >
                                <img
                                  src={productDemoImage}
                                  alt="product demo visual"
                                  className="mt-7"
                                  loading="lazy"
                                />
                                <div className="flex flex-col p-4">
                                  <p className="font-medium text-gray-2700 tracking-[-O.35px] font-manrope text-2.5xl">
                                    See Encord{" "}
                                    <span className="text-purple-1500">
                                      in Action
                                    </span>
                                  </p>
                                  <span className="text-sm tracking-[-O.75px] text-[#262626]">
                                    Explore our interactive product tour
                                  </span>
                                  <CustomButton
                                    text={"Try demo"}
                                    icon={
                                      <ForwardArrow
                                        fill={"#434343"}
                                        className={"w-[14px]"}
                                      />
                                    }
                                    direction={`right`}
                                    buttonClass="!px-3 mb-[2px] !py-2 tracking-[-0.35px] text-sm text-[#434343] hover:bg-black/10 bg-[#F0F0F0] font-manrope mt-4 flex items-center"
                                  />
                                </div>
                              </Link>
                            </div>
                          </section>
                        </section>
                      </nav>
                    </div>
                  </div>
                </Popover.Panel>
              </Transition>
            </div>
          </>
        )}
      </Popover>
    );
  },
);

ProductHeaderButton.displayName = "ProductHeaderButton";

export default ProductHeaderButton;
